import { render } from "./marketInfo.vue?vue&type=template&id=ded3ec36&scoped=true"
import script from "./marketInfo.vue?vue&type=script&lang=js"
export * from "./marketInfo.vue?vue&type=script&lang=js"

import "./marketInfo.vue?vue&type=style&index=0&id=ded3ec36&scoped=true&lang=scss"

import exportComponent from "E:\\Project\\one-code-pass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ded3ec36"]])

export default __exports__